import { Box, Typography } from '@mui/material'
import { bucketColors, type LicensureBucket } from './licensure'

const ITEMS: { bucket: LicensureBucket; label: string }[] = [
  { bucket: 'ok', label: 'Licensed' },
  { bucket: 'pend', label: 'License pending' },
  { bucket: 'bad', label: 'Not licensed' },
  { bucket: 'na', label: 'No license required / not checked' },
]

/** Colour key for the tri-state licensure chips in the results table. */
const LicensureLegend = () => (
  <Box sx={{ display: 'flex', gap: 2.25, flexWrap: 'wrap', mt: 1.75, mb: 0.25 }}>
    {ITEMS.map(item => (
      <Typography
        key={item.bucket}
        component="span"
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 0.875,
          fontSize: 12.5,
          color: 'text.secondary',
        }}
      >
        <Box
          component="span"
          sx={theme => ({
            width: 9,
            height: 9,
            borderRadius: '50%',
            bgcolor: bucketColors(theme, item.bucket).dot,
          })}
        />
        {item.label}
      </Typography>
    ))}
  </Box>
)

export default LicensureLegend
